export enum Configs {
  DRAWER_SIGNIN = "drawer_signin",
  MAIN_MENU_BUTTON = "main_menu_button",
  AVATAR_AUTHENTICATION = "avatar_authentication",
  ACCOUNT_CREATION = "account_creation",
  CONFIG_NAVIGATION = "config_navigation",
  AVATAR_DIALOG = "avatar_dialog",
  WAITER_BUTTON = "waiter_button",
  ADD_ORDER = "add_order",
  LOYALTY_ENABLED = "loyalty_enabled",
  LOYALTY_ADMIN_CONFIG = "loyalty_admin_config",
  LOYALTY_CHECKOUT = "loyalty_checkout",
  LOYALTY_USER_VIEW = "loyalty_user_view",
}

export const remoteConfigInitialValues = {
  [Configs.DRAWER_SIGNIN]: false,
  [Configs.MAIN_MENU_BUTTON]: false,
  [Configs.AVATAR_AUTHENTICATION]: false,
  [Configs.ACCOUNT_CREATION]: false,
  [Configs.CONFIG_NAVIGATION]: false,
  [Configs.AVATAR_DIALOG]: false,
  [Configs.WAITER_BUTTON]: false,
  [Configs.ADD_ORDER]: false,
  [Configs.LOYALTY_ENABLED]: false,
  [Configs.LOYALTY_ADMIN_CONFIG]: false,
  [Configs.LOYALTY_CHECKOUT]: false,
  [Configs.LOYALTY_USER_VIEW]: false,
};

export const DEFAULT_MENU_TEMPLATE = 'ToKMxmVapOJpdYh5k5X0';
export const DEFAULT_WEBSITE_TEMPLATE = 'f8Ki2hlwl5OQqXQPAZv0';
